import { NON_CONTEXTUAL_PACKAGE_NAME } from '../../../../constants/formConstants';
import { GP_SLOT_VALUES, getSlotPackageDisplayName } from '../../constants/DetailedBookingConstants';
import { SlotOptionType, SlotPackage } from '../../interface/DetailedBookingInterface';

interface LoadSlotsProps {
    slotPackages: SlotPackage[],
    setSlotOptions: React.Dispatch<React.SetStateAction<SlotOptionType[]>>,
    setSlotPackagesData: React.Dispatch<React.SetStateAction<SlotPackage[]>>,
}

export const processSlotData = ({
    slotPackages,
    setSlotOptions,
    setSlotPackagesData,
}: LoadSlotsProps) => {
    if (!!slotPackages.length) {
        const flatOptions: SlotOptionType[] = [];

        slotPackages.forEach((pkg) => {
            if (pkg.slotPackageName.toLowerCase() === NON_CONTEXTUAL_PACKAGE_NAME)
                pkg.segments.forEach(({ segmentName }) => {
                    flatOptions.push({
                        id: segmentName,
                        value: segmentName,
                        label: segmentName,
                        type: GP_SLOT_VALUES.NON_CONTEXTUAL,
                    });
                });
            else
                flatOptions.push({
                    id: pkg.slotPackageName,
                    value: pkg.slotPackageName,
                    label: getSlotPackageDisplayName(pkg.slotPackageName),
                    type: GP_SLOT_VALUES.CONTEXTUAL,
                });
        });

        setSlotOptions(flatOptions);
        setSlotPackagesData(slotPackages);
    } else {
        setSlotOptions([]);
        setSlotPackagesData([]);
    }
    return;
};
